
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hxssF", function(module, exports) {

$parcel$export(module.exports, "RecommendPremiumToStandardModalComponent", () => $9125d6c6dde86234$export$e2ad8f867d457fc6);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $joX8T = parcelRequire("joX8T");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $lpwtK = parcelRequire("lpwtK");

var $dRVix = parcelRequire("dRVix");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $5oBMG = parcelRequire("5oBMG");

var $4R6GH = parcelRequire("4R6GH");

var $8y2Jg = parcelRequire("8y2Jg");

var $2LVEz = parcelRequire("2LVEz");
const $9125d6c6dde86234$var$RecommendPremiumToStandardModalComponentImpl = ()=>{
    const cloudID = (0, $koeKL.useCloudId)();
    const RecommendPremiumToStandardModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudIds: [
                cloudID
            ],
            isStandaloneOfferingFGEnabled: (0, $4R6GH.fg)('jira_recommend_standard_query_standalone_offering')
        }), [
        cloudID
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $8y2Jg.recommendPremiumToStandardModalEntryPoint), RecommendPremiumToStandardModalEntryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.jiraRecommendPremiumToStandard",
        packageName: "jira-recommend-premium-to-standard-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: "unmount",
        runtimeProps: {}
    });
};
const $9125d6c6dde86234$var$ExperimentWrapper = ({ children: children })=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_reverse_trial_ea_updates_during_trial');
    const experimentCohort = (0, $5uXOq.useMemo)(()=>config.get('cohort', 'not-enrolled'), [
        config
    ]);
    if (experimentCohort === (0, $joX8T.VARIATION) && (0, $4R6GH.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) return null;
    return children;
};
const $9125d6c6dde86234$export$e2ad8f867d457fc6 = ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const appEditions = (0, $k9JTq.useAppEditions)();
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const productKey = projectType && (0, $2vSU6.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem;
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const daysLeft = (0, $dRVix.getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime) ?? 0;
    const eligibleDaysLeft = daysLeft === 1 || daysLeft === 3 || daysLeft === 5;
    const [reccStdConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('recommend_standard_purchase_in_jira_premium_eot');
    const reccStdExperimentCohort = (0, $5uXOq.useMemo)(()=>reccStdConfig.get('cohort', 'not-enrolled'), [
        reccStdConfig
    ]);
    // dont preload component if not enrolled, correct edition, software project open, not ccp
    if (!(0, $2LVEz.isProjectTypeAndEditionSupported)(appEditions, project?.type) || reccStdExperimentCohort === (0, $joX8T.NOT_ENROLLED) || billingSourceSystem !== 'CCP' || !eligibleDaysLeft) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9125d6c6dde86234$var$ExperimentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9125d6c6dde86234$var$RecommendPremiumToStandardModalComponentImpl, null));
};

});
parcelRegister("8y2Jg", function(module, exports) {

$parcel$export(module.exports, "recommendPremiumToStandardModalEntryPoint", () => $6c0a47fc92e7dcd3$export$cfb9acf6e9b90816);

var $cUBPq = parcelRequire("cUBPq");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $6c0a47fc92e7dcd3$export$cfb9acf6e9b90816 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(async ()=>(parcelRequire("dr2Io")).then(({ RecommendPremiumToStandardModalRenderer: RecommendPremiumToStandardModalRenderer })=>RecommendPremiumToStandardModalRenderer), {
        moduleId: "ca434ceb"
    }),
    getPreloadProps: ({ cloudIds: cloudIds, isStandaloneOfferingFGEnabled: isStandaloneOfferingFGEnabled })=>({
            queries: {
                getRecommendPremiumToStandardUrlQuery: {
                    parameters: (0, $cUBPq.default),
                    variables: {
                        cloudIds: cloudIds,
                        isStandaloneOfferingFGEnabled: isStandaloneOfferingFGEnabled
                    }
                }
            }
        })
});

});
parcelRegister("cUBPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fc4f0c418305bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5247d7df701e654a8a477d8fb833796c>>
 * @relayHash f1349222e8edf4730ccbe4f8945c258d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 964db7270fc909d08496e957a2dac28a6cb9a76e6037014be90d660206dd5040
const $61fc4f0c418305bc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "964db7270fc909d08496e957a2dac28a6cb9a76e6037014be90d660206dd5040",
        "metadata": {},
        "name": "uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery",
        "operationKind": "query",
        "text": null
    }
};
var $61fc4f0c418305bc$export$2e2bcd8739ae039 = $61fc4f0c418305bc$var$node;

});

parcelRegister("dr2Io", function(module, exports) {

let $9c7fe7201b4a76cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c7fe7201b4a76cc$var$load("52Tml").then(()=>parcelRequire('9HVXx'));

});


parcelRegister("2LVEz", function(module, exports) {

$parcel$export(module.exports, "isProjectTypeAndEditionSupported", () => $e648e60ba2ea6512$export$c9a5a2a3868318aa);

var $2vSU6 = parcelRequire("2vSU6");

var $ldyPw = parcelRequire("ldyPw");
const $e648e60ba2ea6512$export$c9a5a2a3868318aa = (applicationEditions, project)=>{
    const projectType = (0, $2vSU6.toProjectType)(project);
    if (!projectType || projectType !== (0, $2vSU6.SOFTWARE_PROJECT)) return false;
    return applicationEditions.software === (0, $ldyPw.PREMIUM_EDITION);
};

});



//# sourceMappingURL=async-recommend-premium-to-standard-modal.9e33561a.js.map
